import { render, staticRenderFns } from "./Workgroups.vue?vue&type=template&id=4a4eccdd"
import script from "./Workgroups.vue?vue&type=script&lang=js"
export * from "./Workgroups.vue?vue&type=script&lang=js"
import style0 from "./Workgroups.vue?vue&type=style&index=0&id=4a4eccdd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports